/**
 * External dependencies
 */
import Global from '@naruto/naruto-reducers/src/stores/global';
import Message from '@naruto/naruto-reducers/src/stores/message';

/**
 * Internal dependencies
 */
import User from '@naruto/bgdcms/src/reducers/stores/user';
import Account from '@naruto/bgdcms/src/reducers/stores/account';
import Project from '@naruto/bgdcms/src/reducers/stores/project';
import Service from '@naruto/bgdcms/src/reducers/stores/service';
import Contact from '@naruto/bgdcms/src/reducers/stores/contact';
import SiteMeta from '@naruto/bgdcms/src/reducers/stores/site-meta';
import Attachment from '@naruto/bgdcms/src/reducers/stores/attachment';
import { Models } from './types';

function initialModel(): Models {
  const model: Models = {
    /* Shared Reducer */
    global: new Global(),
    message: new Message(),
    user: new User(),
    /* App Reducer */
    account: new Account(),
    project: new Project(),
    service: new Service(),
    contact: new Contact(),
    siteMeta: new SiteMeta(),
    attachment: new Attachment()
  };
  return model;
}

export default initialModel;
